.h1,
.h2,
.h3,
.h4,
.h5,
.h6,
h1,
h2,
h3,
h4,
h5,
h6 {
    line-height: 2.4rem;
    margin: 0 0 var(--headers-margin-bottom) 0;
    padding: 0;
    font-weight: 700;
}

h1,
.h1 {
    font-size: var(--h1-font-size);
    line-height: calc(var(--h1-line-height) * var(--h1-font-size));
}

h2,
.h2 {
    font-size: var(--h2-font-size);
    line-height: calc(var(--h2-line-height) * var(--h2-font-size));
}

h3,
.h3 {
    font-size: var(--h3-font-size);
    line-height: calc(var(--h5-line-height) * var(--h3-font-size));
}

h4,
.h4 {
    font-size: var(--h4-font-size);
    line-height: calc(var(--h5-line-height) * var(--h4-font-size));
}

h5,
.h5 {
    font-size: var(--h5-font-size);
    line-height: calc(var(--h5-line-height) * var(--h5-font-size));
}

h6,
.h6 {
    font-size: var(--h6-font-size);
    line-height: calc(var(--h6-line-height) * var(--h6-font-size));
}

.h1-font-size {
    font-size: var(--h1-font-size);
}

.h2-font-size {
    font-size: var(--h2-font-size);
}

.h3-font-size {
    font-size: var(--h3-font-size);
}

.h4-font-size {
    font-size: var(--h4-font-size);
}

.h5-font-size {
    font-size: var(--h5-font-size);
}

.h6-font-size {
    font-size: var(--h6-font-size);
}

@media (max-width: 768px) {

    h1,
    .h1 {
        font-size: var(--h1-font-size-medium-only);
        line-height: calc(var(--h1-line-height-medium-only) * var(--h1-font-size-medium-only) * 0.1rem);
    }

    h2,
    .h2 {
        font-size: var(--h2-font-size-medium-only);
        line-height: calc(var(--h2-line-height-medium-only) * var(--h2-font-size-medium-only) * 0.1rem);
    }

    h3,
    .h3 {
        font-size: var(--h3-font-size-medium-only);
        line-height: calc(var(--h3-line-height-medium-only) * var(--h3-font-size-medium-only));
    }

    h4,
    .h4 {
        font-size: var(--h4-font-size-medium-only);
        line-height: calc(var(--h4-line-height-medium-only) * var(--h4-font-size-medium-only));
    }
}

@media (max-width: 480px) {

    h1,
    .h1 {
        font-size: var(--h1-font-size-small-only);
        line-height: calc(var(--h1-line-height-small-only) * var(--h1-font-size-small-only));
    }

    h2,
    .h2 {
        font-size: var(--h2-font-size-small-only);
        line-height: calc(var(--h2-line-height-small-only) * var(--h2-font-size-small-only));
    }

    h3,
    .h3 {
        font-size: var(--h3-font-size-small-only);
        line-height: calc(var(--h3-line-height-small-only) * var(--h3-font-size-small-only));
    }

    h4,
    .h4 {
        font-size: var(--h4-font-size-small-only);
        line-height: calc(var(--h4-line-height-small-only) * var(--h4-font-size-small-only));
    }
}